import React from 'react';
import style from './RiskReward.css';
import { getRRDisplay } from './util';

const RiskReward = ({
  fundRiskReward,
  name,
  ticker,
  toggleRiskRewardModal
}) => {
  const rrDisplay = getRRDisplay(fundRiskReward);
  return (
    <div className="risk-reward">
      <button
        type="button"
        className="riskRewardLink btn-clear-bg"
        onClick={() => toggleRiskRewardModal(fundRiskReward, { name, ticker })}>
        <div className={`rr-range-name ${rrDisplay.name.toLowerCase()}`}>
          {rrDisplay.name}
        </div>
        <div>
          <input
            max="290"
            min="200"
            disabled
            readOnly
            className={`riskRewardClick rr-slider-v2 ${rrDisplay.class}`}
            type="range"
            value={fundRiskReward}
          />
        </div>
        <div
          className={`rr-range-percent-text ${rrDisplay.name.toLowerCase()}`}>
          {rrDisplay.label}
        </div>
      </button>
      <style jsx>{style}</style>
    </div>
  );
};

export default RiskReward;
